import { render, staticRenderFns } from "./CategoriesTags.vue?vue&type=template&id=59a2713c&scoped=true&"
import script from "./CategoriesTags.vue?vue&type=script&lang=js&"
export * from "./CategoriesTags.vue?vue&type=script&lang=js&"
import style0 from "./CategoriesTags.vue?vue&type=style&index=0&id=59a2713c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59a2713c",
  null
  
)

export default component.exports